import superagent from 'superagent';

export default async function getSepomex(cp) {
  let url = `${process.env.REACT_APP_WEBSERVICE_MX}/getSepomex?cp=${cp}`;

  let response = {};

  await superagent
    .get(url)
    .set('Content-Type', 'application/json')
    .then((res) => {
      response = res.body;
    })
    .catch((err) => {
      console.log(err);
      const resp = {
        error: err,
        tipoMensaje: 'error',
        mensaje: 'Error',
      };
      response = resp;
    });

  return response;
}
